// extracted by mini-css-extract-plugin
export default {"root":"Faq_root__AiKAK","link":"Faq_link__7Pzjg"};